import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Cloud, Sun, CloudRain, CloudSnow, Wind } from "lucide-react";

const codeMap = (c) => {
  if (c === 0) return { label: "Clear", Icon: Sun };
  if (c <= 3) return { label: "Partly cloudy", Icon: Cloud };
  if (c <= 48) return { label: "Foggy", Icon: Cloud };
  if (c <= 67) return { label: "Rainy", Icon: CloudRain };
  if (c <= 77) return { label: "Snowy", Icon: CloudSnow };
  if (c <= 82) return { label: "Showers", Icon: CloudRain };
  return { label: "Cloudy", Icon: Cloud };
};

export default function WeatherWidget({ lat, lon, city, region }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    if (lat == null && !city) return;
    const params = {};
    if (lat != null && lon != null) { params.lat = lat; params.lon = lon; }
    else { params.city = city; if (region) params.region = region; }
    api.get("/weather", { params })
      .then((r) => setData(r.data))
      .catch(() => setErr(true));
  }, [lat, lon, city, region]);

  if (err) return null;
  if (!data) return <div className="h-40 w-full skeleton rounded-3xl" data-testid="weather-skeleton" />;

  const cur = data.current || {};
  const { label, Icon } = codeMap(cur.weather_code ?? 0);
  const daily = data.daily || {};

  return (
    <div data-testid="weather-widget" className="rounded-3xl bg-navy p-6 text-white" style={{ backgroundColor: "#002244" }}>
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm text-white/60">Current Weather</p>
          <div className="mt-1 flex items-end gap-2">
            <span className="font-display text-5xl font-extrabold">{Math.round(cur.temperature_2m)}°</span>
            <span className="mb-1 text-sm text-white/80">{label}</span>
          </div>
          <p className="mt-1 flex items-center gap-1 text-xs text-white/60"><Wind className="h-3.5 w-3.5" /> {cur.wind_speed_10m} km/h</p>
        </div>
        <Icon className="h-16 w-16 text-brandorange" />
      </div>
      <div className="mt-5 grid grid-cols-4 gap-2">
        {(daily.time || []).slice(0, 4).map((t, i) => {
          const d = codeMap(daily.weather_code?.[i] ?? 0);
          const D = d.Icon;
          return (
            <div key={t} className="rounded-2xl bg-white/10 py-3 text-center">
              <p className="text-[11px] text-white/60">{new Date(t).toLocaleDateString("en", { weekday: "short" })}</p>
              <D className="mx-auto my-1 h-5 w-5 text-brandorange" />
              <p className="text-xs font-semibold">{Math.round(daily.temperature_2m_max?.[i])}°</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
